<template>
  <div class="d-flex flex-row align-center width-100 flex-wrap justify-center">
    <div class="d-flex d-sm-none flex-row align-center justify-center barlow-bold px-4 my-6">
      <div class="text-uppercase jost-bold">Distance: {{ riding.distance | kilometers }} km / {{ riding.distance | miles }} mi</div>
    </div>
    <!-- Duration -->
    <div class="duration-wrapper flex-1 d-flex flex-row align-center justify-start">
      <div class="duration-container d-flex flex-column position-relative mr-4">
        <div class="position-absolute width-100 text-center barlow-bold mt-4">{{ duration }}</div>
        <img src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FDAYS.svg?alt=media&token=f1f1ee7e-8cb0-4c54-b787-446ea12a177a" alt="">
      </div>
      <!-- Difficulty -->
      <v-menu left offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="difficulty-container d-flex flex-row align-center px-4 justify-center" v-bind="attrs" v-on="on">
            <img v-if="riding.difficulty.rating == 1" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FSKILL-LEVEL-1.svg?alt=media&token=034bc977-ffe9-47a7-8570-2b5896c65809" alt="">  
            <img v-if="riding.difficulty.rating == 2" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FSKILL-LEVEL-2.svg?alt=media&token=2cdd8365-a3f3-4d9a-a2ce-3161b1cba582" alt="">
            <img v-if="riding.difficulty.rating == 3" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FSKILL-LEVEL-3.svg?alt=media&token=37c27ab8-42cd-4994-9d9d-5b317b0bb017" alt="">
            <div class="rating-description d-flex flex-column align-center justify-center">
              <div v-if="riding.difficulty.rating == 1" class="text-uppercase jost-bold">Basic</div>
              <div v-if="riding.difficulty.rating == 2" class="text-uppercase jost-bold">Intermediate</div>
              <div v-if="riding.difficulty.rating == 3" class="text-uppercase jost-bold">Advanced</div>
              <div class="text-caption rating-description">
                {{ riding.difficulty.ratingDescription }}
              </div>
            </div>
          </div>
        </template>
        <v-card class="pa-3 flex-1" width="400">
          <div class="text-body-2">{{ riding.difficulty.ratingDescription }}</div>
        </v-card>
      </v-menu>
      <!-- Distance -->
      <div class="d-none d-sm-flex distance-container flex-column align-center justify-center barlow-bold px-4">
        <div class="text-uppercase jost-bold">Distance:</div>
        <div class="jost-bold font-size-16">{{ riding.distance | kilometers }} km /</div>
        <div class="jost-bold font-size-16">{{ riding.distance | miles }} mi</div>
      </div>
    </div>
    <!-- Distance-->
    <div class="distance-wrapper d-flex flex-row align-center justify-center">
      <!-- Paved -->
      <div class="paved-container d-flex flex-row align-center ml-4">
        <img class="mr-2" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FPAVED.svg?alt=media&token=e400add1-41a4-4089-9ee7-a726b813b626" alt="" />
        <div class="d-flex flex-column text-center">
          <div class="text-uppercase jost-bold">Paved</div>
          <div class="jost-regular font-size-20 line-height-1-1">{{ riding.difficulty.paved }}%</div>
        </div>
      </div>
      <!-- Gravel -->
      <div class="gravel-container d-flex flex-row align-center ml-4">
        <img class="mr-2" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FGRAVEL.svg?alt=media&token=87ad5d91-32d9-4b7e-89df-68628e1de9de" alt="" />
        <div class="d-flex flex-column text-center">
          <div class="text-uppercase jost-bold">Gravel</div>
          <div class="jost-regular font-size-20 line-height-1-1">{{ riding.difficulty.gravel }}%</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'RidingBar',
  props: {
    riding: {
      type: Object,
      required: true
    },
    duration: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      effectiveWidth: 0
    }
  },
  computed: {
    isLoading() {
      return this.loading || !this.riding || !this.riding.difficulty || this.duration === null || this.duration === undefined
    }
  },
  methods: {
    updateSizes() {
      if (this.$refs.duration) {
        this.effectiveWidth = this.$refs.duration.offsetWidth;
      }
    }
  },
  mounted() {
    this.$nextTick(this.updateSizes);
    window.addEventListener('resize', this.updateSizes);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateSizes);
  },
  filters: {
    kilometers: function(value) {
      return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    miles: function(value) {
      return (value * 0.621371).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>

<style scoped>
  .duration-wrapper {
    /* border: 1px solid blue; */
    height: 90px;
  }
  .distance-wrapper {
    /* border: 1px solid green; */
    height: 90px;
  }
  .duration-container {
    width: 70px;
    height: 70px;
    font-size: 35px;
  }
  .distance-container {
    height: 80px;
    min-width: 140px;
    line-height: 1.1rem;
    border-left: 1px solid black;
  }
  .paved-container {
    min-width: 120px;
    flex-shrink: 0;
    img { height: 45px; }
  }
  .gravel-container {
    min-width: 120px;
    flex-shrink: 0;
    img { height: 45px; }
  }
  .difficulty-container {
    display: flex;
    /* max-width: 400px; */
    border-left: 1px solid black;
    flex: 1;
    img { 
      height: 65px; 
      margin-right: 10px;
    }
  }
  .rating-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .line-height-1-1 {
    line-height: 1.1rem;
  }
</style>